import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'

import { apiConstants } from '../constants/apiConstants'
import { constants } from '../constants/constants'
import { removeExtraSlashes } from '../helper'

class BreadCrumbs extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {}
  }

  onBreadCrumbsClick = (baseFolder, index) => {
    const { userPermission } = this.props

    const basePath =
      baseFolder === '/' ? [] : removeExtraSlashes(baseFolder).split('/')

    let path = ''

    if (baseFolder === '/') {
      path = apiConstants.Root
    } else {
      basePath.length = index + 1
      path = basePath.join('/')
    }

    this.props.actions.setUserPermissionForFolder(userPermission)
    this.props.setPreviousBaseFolder(baseFolder)
    this.props.setBaseFolder(path)
    this.props.history.push(`${apiConstants.URLPrefix}/${path}`)
    this.props.handleClearDate()
  }

  onMouseOverToolTip = (e) => {
    const rect = e.target.getBoundingClientRect()
    if (e.target.children[0]) {
      e.target.children[0].style.top = `${rect.top + 20}px`
      e.target.children[0].style.left = `${rect.left + 60}px`
    }
  }

  renderRootParent = () => {
    const { searchQuery } = this.props

    if (searchQuery.quickSearch) {
      return searchQuery.quickSearch === 'sharedBy' ? 'sharedBy' : 'sharedWith'
    }
    return 'list.title'
  }

  getBreadCrumbRootName = () => {
    const { searchQuery } = this.props

    if (searchQuery.quickSearch) {
      return searchQuery.quickSearch === 'sharedBy'
        ? 'sharedByMe'
        : 'sharedWithMe'
    }
    return 'home'
  }

  renderBreadCrumbs = (baseFolder) => {
    const { shareePath, sharedFolderDetails, user, folderList } = this.props
    let breadCrumbs = sharedFolderDetails.shareePath
      ? removeExtraSlashes(shareePath).split('/')
      : removeExtraSlashes(baseFolder).split('/')

    const rootFolderInfo = folderList.results.filter(function (folder) {
      return folder.fileName === breadCrumbs[0]
    })
    if (
      rootFolderInfo.length > 0 &&
      _.has(rootFolderInfo[0], 'enableEmailMask') &&
      rootFolderInfo[0].enableEmailMask &&
      user.accType === constants.AdhocUser
    ) {
      breadCrumbs[0] = breadCrumbs[0].replace(
        /(([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+))$/,
        '',
      )
    }
    return (
      <div className="breadCrumb__container">
        <div className="ppvx_text--md breadCrumb__content">
          <a
            className={` breadCrumbs__links-label ${
              baseFolder !== '/'
                ? 'ppvx_link breadCrumbs__links--active'
                : 'breadCrumbs__links'
            }`}
            data-pa-pgrp={`dropzone:${user.accType}`}
            data-pa-page={`dropzone:search:${this.getBreadCrumbRootName()}:${
              user.accType
            }`}
            data-pa-click={this.getBreadCrumbRootName()}
            onClick={() => this.props.onBreadCrumbsRootParentClick()}
          >
            <Message id={`labels.${this.renderRootParent()}`} />
          </a>
          {breadCrumbs.map((item, index) => {
            return (
              <div key={index} style={{ display: 'flex' }}>
                {baseFolder !== '/' && (
                  <div className="breadCrumbs__links-label breadCrumbs__separator">
                    /
                  </div>
                )}
                <a
                  className={`breadCrumbs__links-label ${
                    breadCrumbs.length !== index + 1
                      ? 'ppvx_link breadCrumbs__links--active'
                      : 'breadCrumbs__links'
                  }`}
                  data-pa-pgrp={`dropzone:${user.accType}`}
                  data-pa-page={`dropzone:search:breadcrumb:folder:${user.accType}`}
                  data-pa-click="search"
                  onClick={() => this.onBreadCrumbsClick(baseFolder, index)}
                >
                  <div
                    className="tooltip"
                    onMouseOver={(e) => this.onMouseOverToolTip(e)}
                  >
                    {item.length > 25 ? `${item.substring(0, 25)}...` : item}
                    {item.length > 25 && (
                      <span className="tooltiptext">{item}</span>
                    )}
                  </div>
                </a>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    const { baseFolder } = this.props
    return <div>{this.renderBreadCrumbs(baseFolder)}</div>
  }
}

export default BreadCrumbs
